/** @jsxImportSource @emotion/react */
import React from 'react';
import PropTypes from 'prop-types';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import InfoIcon from '@mui/icons-material/Info';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import SnackbarContent from '@mui/material/SnackbarContent';
import WarningIcon from '@mui/icons-material/Warning';

const MySnackbarContentWrapper = React.forwardRef(function SnackbarWrapper(props, ref) {
  const { className, message, onClose, variant, ...other } = props;
  const variantIcon = {
    success: CheckCircleIcon,
    warning: WarningIcon,
    error: ErrorIcon,
    info: InfoIcon,
  };
  const Icon = variantIcon[variant];

  const classes = {
    success: {
      backgroundColor: "#EDE3FE"
    },
    error: {
      backgroundColor: "#F8D7DA",
    },
    info: {
      backgroundColor: "#E3F1FF"
    },
    warning: {
      backgroundColor: "#FFF3CD"
    },
    icon: {
      fontSize: 20,
    },
    iconVariant: {
      opacity: 0.9,
      marginRight: "10px",
    },
    message: {
      display: 'flex',
      alignItems: 'center',
      fontSize: "16px",
      paddingLeft: "20px"
    },
    errorFontColor: {
      color: "#BC2232"
    },
    successFontColor: {
      color: "#786397"
    },
    infoFontColor: {
      color: "#3276B1"
    },
    warningFontColor: {
      color: "#EB6E00"
    }
  }

  return (
    <div ref={ref}>
      <SnackbarContent
        css={classes[variant]}
        aria-describedby="client-snackbar"
        message={
          <span id="client-snackbar"
            css={variant == "error" ?
              {...classes.errorFontColor, ...classes.message}
              : variant == "success" ?
                {...classes.successFontColor, ...classes.message}
                : variant == "warning" ?
                  {...classes.warningFontColor, ...classes.message}
                  : variant == "info"
                  && {...classes.infoFontColor, ...classes.message}
            }
          >
            {/* <Icon className={classNames(classes.icon, classes.iconVariant)} /> */}
            {message}
          </span>
        }
        action={[
          <IconButton
            key="close"
            aria-label="Close"
            color="inherit"
            onClick={onClose}
            size="large"
            css={{padding:"0px"}}
          >
            <CloseIcon
              css={variant == "error" ?
                {...classes.errorFontColor, ...classes.icon}
                : variant == "success" ?
                  {...classes.successFontColor, ...classes.icon}
                  : variant == "warning" ?
                    {...classes.warningFontColor, ...classes.icon}
                    : variant == "info"
                    && {...classes.infoFontColor, ...classes.icon}
              }
            />
          </IconButton>,
        ]}
        {...other}
      />
    </div>
  );
})

MySnackbarContentWrapper.propTypes = {
  className: PropTypes.string,
  message: PropTypes.node,
  onClose: PropTypes.func,
  variant: PropTypes.oneOf(['success', 'warning', 'error', 'info']).isRequired,
};

export default MySnackbarContentWrapper;